import { Component, HostListener, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../i18n/pipes/translate.pipe';
import { UiCorePipesModule } from '../../../pipes/ui-core-pipes.module';
import { ResolvableModal } from '../../abstraction/modal';
import { ConfirmResult } from '../../types/confirm-result';

@Component({
  selector: 'soft-confirm-modal',
  imports: [CommonModule, TranslatePipe, UiCorePipesModule],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.css',
})
export class ConfirmModalComponent extends ResolvableModal<ConfirmResult> {
  showAbort = input(false);

  @HostListener('window:keydown.enter')
  onClick(result: ConfirmResult = 'YES'): void {
    this.resolve(result);
  }
}
